const axios = require("axios");

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

export const getChannels = async () => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +'channels?type=external'
           ,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};
export const getChannelConfig = async (id) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `channels/${id}/config`
        ,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};
